import { createCompanyApiConfig } from './platform-selector.api';

export const CREATE_CLIENT_REQUEST_CALLED = '@domain/platform/platform-selector/CREATE_CLIENT_REQUEST_CALLED';
export const CREATE_CLIENT_REQUEST_SUCCEEDED = '@domain/platform/platform-selector/CREATE_CLIENT_REQUEST_SUCCEEDED';
export const CREATE_CLIENT_REQUEST_FAILED = '@domain/platform/platform-selector/CREATE_CLIENT_REQUEST_FAILED';

export const createClient = company => ({
    type: CREATE_CLIENT_REQUEST_CALLED,
    actionTypes: {
        success: CREATE_CLIENT_REQUEST_SUCCEEDED,
        fail: CREATE_CLIENT_REQUEST_FAILED,
    },
    config: createCompanyApiConfig(company),
});
